(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './compose-multiplatform-core-compose-ui-ui.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-ui-ui-graphics.js', './compose-multiplatform-core-compose-foundation-foundation.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './compose-multiplatform-core-compose-animation-animation-core.js', './androidx-compose-runtime-runtime.js', './compose-multiplatform-core-compose-ui-ui-util.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./compose-multiplatform-core-compose-ui-ui.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-ui-ui-graphics.js'), require('./compose-multiplatform-core-compose-foundation-foundation.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./compose-multiplatform-core-compose-animation-animation-core.js'), require('./androidx-compose-runtime-runtime.js'), require('./compose-multiplatform-core-compose-ui-ui-util.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-ui-ui' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-ui-ui-graphics' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-graphics' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-foundation-foundation'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-foundation-foundation' was not found. Please, check whether 'compose-multiplatform-core-compose-foundation-foundation' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-animation-animation-core'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-animation-animation-core' was not found. Please, check whether 'compose-multiplatform-core-compose-animation-animation-core' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['androidx-compose-runtime-runtime'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'androidx-compose-runtime-runtime' was not found. Please, check whether 'androidx-compose-runtime-runtime' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-material-material-ripple'. Its dependency 'compose-multiplatform-core-compose-ui-ui-util' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-util' is loaded prior to 'compose-multiplatform-core-compose-material-material-ripple'.");
    }
    globalThis['compose-multiplatform-core-compose-material-material-ripple'] = factory(typeof globalThis['compose-multiplatform-core-compose-material-material-ripple'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-material-material-ripple'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['compose-multiplatform-core-compose-ui-ui'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['compose-multiplatform-core-compose-foundation-foundation'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['compose-multiplatform-core-compose-animation-animation-core'], globalThis['androidx-compose-runtime-runtime'], globalThis['compose-multiplatform-core-compose-ui-ui-util']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_compose_ui_ui, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_ui_ui_graphics, kotlin_org_jetbrains_compose_foundation_foundation, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_compose_animation_animation_core, kotlin_androidx_compose_runtime_runtime, kotlin_org_jetbrains_compose_ui_ui_util) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var isInterface = kotlin_kotlin.$_$.rg;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var invalidateDraw = kotlin_org_jetbrains_compose_ui_ui.$_$.d6;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var VOID = kotlin_kotlin.$_$.d;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var MutableScatterMap = kotlin_androidx_collection_collection.$_$.n;
  var invert = kotlin_kotlin.$_$.qe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var Long = kotlin_kotlin.$_$.kn;
  var compare = kotlin_kotlin.$_$.je;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var Color__copy$default_impl_ectz3s = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.x3;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var Interaction = kotlin_org_jetbrains_compose_foundation_foundation.$_$.r;
  var PressInteraction = kotlin_org_jetbrains_compose_foundation_foundation.$_$.w;
  var Cancel = kotlin_org_jetbrains_compose_foundation_foundation.$_$.t;
  var Release = kotlin_org_jetbrains_compose_foundation_foundation.$_$.v;
  var Press = kotlin_org_jetbrains_compose_foundation_foundation.$_$.u;
  var equals = kotlin_kotlin.$_$.sf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Node = kotlin_org_jetbrains_compose_ui_ui.$_$.qa;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var MutableObjectList = kotlin_androidx_collection_collection.$_$.m;
  var requireDensity = kotlin_org_jetbrains_compose_ui_ui.$_$.l6;
  var toSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t1;
  var _Dp___get_value__impl__geb1vb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l2;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var onMeasureResultChanged = kotlin_org_jetbrains_compose_ui_ui.$_$.a5;
  var onPlaced = kotlin_org_jetbrains_compose_ui_ui.$_$.d5;
  var CompositionLocalConsumerModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.w4;
  var DrawModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.b5;
  var LayoutAwareModifierNode = kotlin_org_jetbrains_compose_ui_ui.$_$.f5;
  var Animatable = kotlin_org_jetbrains_compose_animation_animation_core.$_$.a;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var Cancel_0 = kotlin_org_jetbrains_compose_foundation_foundation.$_$.k;
  var Stop = kotlin_org_jetbrains_compose_foundation_foundation.$_$.m;
  var Start = kotlin_org_jetbrains_compose_foundation_foundation.$_$.l;
  var Unfocus = kotlin_org_jetbrains_compose_foundation_foundation.$_$.o;
  var Focus = kotlin_org_jetbrains_compose_foundation_foundation.$_$.n;
  var Exit = kotlin_org_jetbrains_compose_foundation_foundation.$_$.q;
  var Enter = kotlin_org_jetbrains_compose_foundation_foundation.$_$.p;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.f4;
  var get_LinearEasing = kotlin_org_jetbrains_compose_animation_animation_core.$_$.m;
  var TweenSpec = kotlin_org_jetbrains_compose_animation_animation_core.$_$.s;
  var tween = kotlin_org_jetbrains_compose_animation_animation_core.$_$.z1;
  var get_FastOutSlowInEasing = kotlin_org_jetbrains_compose_animation_animation_core.$_$.k;
  var KMutableProperty1 = kotlin_kotlin.$_$.wi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var coroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s2;
  var mutableStateOf = kotlin_androidx_compose_runtime_runtime.$_$.b2;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var lerp = kotlin_org_jetbrains_compose_ui_ui_util.$_$.d;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var _Color___get_alpha__impl__wcfyv1 = kotlin_org_jetbrains_compose_ui_ui_graphics.$_$.v2;
  var Offset__getDistance_impl_pclvxn = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.v;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(CommonRippleNode$addRipple$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(RippleNode, 'RippleNode', VOID, Node, [CompositionLocalConsumerModifierNode, DrawModifierNode, LayoutAwareModifierNode]);
  initMetadataForClass(CommonRippleNode, 'CommonRippleNode', VOID, RippleNode);
  initMetadataForLambda(RippleNode$onAttach$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(RippleNode$onAttach$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StateLayer$handleInteraction$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(StateLayer$handleInteraction$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForClass(StateLayer, 'StateLayer');
  initMetadataForLambda(RippleAnimation$fadeIn$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RippleAnimation$fadeIn$slambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RippleAnimation$fadeIn$slambda$slambda_3, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RippleAnimation$fadeOut$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RippleAnimation$fadeIn$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(RippleAnimation$fadeOut$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($animateCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($fadeInCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($fadeOutCOROUTINE$, CoroutineImpl);
  initMetadataForClass(RippleAnimation, 'RippleAnimation', VOID, VOID, VOID, [0]);
  initMetadataForClass(RippleAlpha, 'RippleAlpha');
  //endregion
  var androidx_compose_material_ripple_CommonRipple$stable;
  var androidx_compose_material_ripple_CommonRippleNode$stable;
  function CommonRippleNode$addRipple$slambda($rippleAnimation, this$0, $interaction, resultContinuation) {
    this.vmv_1 = $rippleAnimation;
    this.wmv_1 = this$0;
    this.xmv_1 = $interaction;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CommonRippleNode$addRipple$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(CommonRippleNode$addRipple$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CommonRippleNode$addRipple$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.n9_1 = 2;
            suspendResult = this.vmv_1.kmw(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 5;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            this.wmv_1.kmx_1.a3(this.xmv_1);
            invalidateDraw(this.wmv_1);
            return Unit_instance;
          case 4:
            this.o9_1 = 5;
            var t = this.q9_1;
            this.wmv_1.kmx_1.a3(this.xmv_1);
            invalidateDraw(this.wmv_1);
            throw t;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(CommonRippleNode$addRipple$slambda).q24 = function ($this$launch, completion) {
    var i = new CommonRippleNode$addRipple$slambda(this.vmv_1, this.wmv_1, this.xmv_1, completion);
    i.ymv_1 = $this$launch;
    return i;
  };
  function CommonRippleNode$addRipple$slambda_0($rippleAnimation, this$0, $interaction, resultContinuation) {
    var i = new CommonRippleNode$addRipple$slambda($rippleAnimation, this$0, $interaction, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function CommonRippleNode(interactionSource, bounded, radius, color, rippleAlpha) {
    RippleNode.call(this, interactionSource, bounded, radius, color, rippleAlpha);
    this.kmx_1 = new MutableScatterMap();
  }
  protoOf(CommonRippleNode).lmx = function (interaction, size, targetRadius) {
    // Inline function 'androidx.collection.ScatterMap.forEach' call
    var this_0 = this.kmx_1;
    var k = this_0.x12_1;
    var v = this_0.y12_1;
    $l$block: {
      // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
      var m = this_0.w12_1;
      var lastIndex = m.length - 2 | 0;
      var inductionVariable = 0;
      if (inductionVariable <= lastIndex)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var slot = m[i];
          // Inline function 'androidx.collection.maskEmptyOrDeleted' call
          var this_1 = slot;
          var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
          if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
            var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
            var inductionVariable_0 = 0;
            if (inductionVariable_0 < bitCount)
              do {
                var j = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                // Inline function 'androidx.collection.isFull' call
                var value = bitwiseAnd(slot, new Long(255, 0));
                if (compare(value, new Long(128, 0)) < 0) {
                  var index = (i << 3) + j | 0;
                  k[index];
                  v[index].mmx();
                }
                slot = shiftRight(slot, 8);
              }
               while (inductionVariable_0 < bitCount);
            if (!(bitCount === 8)) {
              break $l$block;
            }
          }
        }
         while (!(i === lastIndex));
    }
    var origin = this.cmy_1 ? interaction.yi8_1 : null;
    var rippleAnimation = new RippleAnimation(origin, targetRadius, this.cmy_1);
    this.kmx_1.h13(interaction, rippleAnimation);
    var tmp = this.a8w();
    launch(tmp, VOID, VOID, CommonRippleNode$addRipple$slambda_0(rippleAnimation, this, interaction, null));
    invalidateDraw(this);
  };
  protoOf(CommonRippleNode).mmy = function (interaction) {
    var tmp0_safe_receiver = this.kmx_1.w2(interaction);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.mmx();
    }
  };
  protoOf(CommonRippleNode).nmy = function (_this__u8e3s4) {
    var alpha = this.fmy_1().rmy_1;
    if (!(alpha === 0.0)) {
      // Inline function 'androidx.collection.ScatterMap.forEach' call
      var this_0 = this.kmx_1;
      var k = this_0.x12_1;
      var v = this_0.y12_1;
      $l$block: {
        // Inline function 'androidx.collection.ScatterMap.forEachIndexed' call
        var m = this_0.w12_1;
        var lastIndex = m.length - 2 | 0;
        var inductionVariable = 0;
        if (inductionVariable <= lastIndex)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var slot = m[i];
            // Inline function 'androidx.collection.maskEmptyOrDeleted' call
            var this_1 = slot;
            var tmp$ret$2 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
            if (!equalsLong(tmp$ret$2, new Long(-2139062144, -2139062144))) {
              var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < bitCount)
                do {
                  var j = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'androidx.collection.isFull' call
                  var value = bitwiseAnd(slot, new Long(255, 0));
                  if (compare(value, new Long(128, 0)) < 0) {
                    var index = (i << 3) + j | 0;
                    k[index];
                    // Inline function 'kotlin.with' call
                    v[index].tmy(_this__u8e3s4, Color__copy$default_impl_ectz3s(this.smy(), alpha));
                  }
                  slot = shiftRight(slot, 8);
                }
                 while (inductionVariable_0 < bitCount);
              if (!(bitCount === 8)) {
                break $l$block;
              }
            }
          }
           while (!(i === lastIndex));
      }
    }
  };
  protoOf(CommonRippleNode).h8w = function () {
    this.kmx_1.c3();
  };
  function get_DefaultTweenSpec() {
    _init_properties_Ripple_kt__d55ieo();
    return DefaultTweenSpec;
  }
  var DefaultTweenSpec;
  var androidx_compose_material_ripple_Ripple$stable;
  var androidx_compose_material_ripple_RippleIndicationInstance$stable;
  var androidx_compose_material_ripple_RippleNode$stable;
  function createRippleModifierNode(interactionSource, bounded, radius, color, rippleAlpha) {
    _init_properties_Ripple_kt__d55ieo();
    return createPlatformRippleNode(interactionSource, bounded, radius, color, rippleAlpha);
  }
  function RippleNode$onAttach$slambda$slambda(this$0, $this_launch, resultContinuation) {
    this.cmz_1 = this$0;
    this.dmz_1 = $this_launch;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleNode$onAttach$slambda$slambda).zg1 = function (interaction, $completion) {
    var tmp = this.ag2(interaction, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleNode$onAttach$slambda$slambda).ja = function (p1, $completion) {
    return this.zg1((!(p1 == null) ? isInterface(p1, Interaction) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleNode$onAttach$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_subject = this.emz_1;
          if (isInterface(tmp0_subject, PressInteraction)) {
            if (this.cmz_1.kmy_1) {
              handlePressInteraction(this.cmz_1, this.emz_1);
            } else {
              var tmp0 = this.cmz_1.lmy_1;
              var element = this.emz_1;
              tmp0.j1(element);
            }
          } else {
            updateStateLayer(this.cmz_1, this.emz_1, this.dmz_1);
          }
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(RippleNode$onAttach$slambda$slambda).ag2 = function (interaction, completion) {
    var i = new RippleNode$onAttach$slambda$slambda(this.cmz_1, this.dmz_1, completion);
    i.emz_1 = interaction;
    return i;
  };
  function RippleNode$onAttach$slambda$slambda_0(this$0, $this_launch, resultContinuation) {
    var i = new RippleNode$onAttach$slambda$slambda(this$0, $this_launch, resultContinuation);
    return constructCallableReference(function (interaction, $completion) {
      return i.zg1(interaction, $completion);
    }, 1);
  }
  function handlePressInteraction($this, pressInteraction) {
    if (pressInteraction instanceof Press) {
      $this.lmx(pressInteraction, $this.jmy_1, $this.imy_1);
    } else {
      if (pressInteraction instanceof Release) {
        $this.mmy(pressInteraction.zi8_1);
      } else {
        if (pressInteraction instanceof Cancel) {
          $this.mmy(pressInteraction.ai9_1);
        }
      }
    }
  }
  function updateStateLayer($this, interaction, scope) {
    var tmp0_elvis_lhs = $this.hmy_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new StateLayer($this.cmy_1, $this.fmy_1);
      invalidateDraw($this);
      $this.hmy_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stateLayer = tmp;
    stateLayer.kmz(interaction, scope);
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.lmz_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.lmz_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.lmz_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function RippleNode$onAttach$slambda(this$0, resultContinuation) {
    this.umz_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleNode$onAttach$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleNode$onAttach$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleNode$onAttach$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            var tmp_0 = this.umz_1.bmy_1.eg3();
            var tmp_1 = RippleNode$onAttach$slambda$slambda_0(this.umz_1, this.vmz_1, null);
            suspendResult = tmp_0.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RippleNode$onAttach$slambda).q24 = function ($this$launch, completion) {
    var i = new RippleNode$onAttach$slambda(this.umz_1, completion);
    i.vmz_1 = $this$launch;
    return i;
  };
  function RippleNode$onAttach$slambda_0(this$0, resultContinuation) {
    var i = new RippleNode$onAttach$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RippleNode(interactionSource, bounded, radius, color, rippleAlpha) {
    Node.call(this);
    this.bmy_1 = interactionSource;
    this.cmy_1 = bounded;
    this.dmy_1 = radius;
    this.emy_1 = color;
    this.fmy_1 = rippleAlpha;
    this.gmy_1 = false;
    this.hmy_1 = null;
    this.imy_1 = 0.0;
    this.jmy_1 = Companion_getInstance().j5e_1;
    this.kmy_1 = false;
    var tmp = this;
    // Inline function 'androidx.collection.mutableObjectListOf' call
    tmp.lmy_1 = new MutableObjectList();
  }
  protoOf(RippleNode).b8w = function () {
    return this.gmy_1;
  };
  protoOf(RippleNode).smy = function () {
    return this.emy_1.c6g();
  };
  protoOf(RippleNode).u91 = function (size) {
    this.kmy_1 = true;
    var density = requireDensity(this);
    this.jmy_1 = toSize(size);
    var tmp = this;
    // Inline function 'kotlin.with' call
    var tmp_0;
    // Inline function 'androidx.compose.ui.unit.isUnspecified' call
    var this_0 = this.dmy_1;
    if (isNaN_0(_Dp___get_value__impl__geb1vb(this_0))) {
      tmp_0 = getRippleEndRadius(density, this.cmy_1, this.jmy_1);
    } else {
      tmp_0 = density.v5e(this.dmy_1);
    }
    tmp.imy_1 = tmp_0;
    // Inline function 'androidx.collection.ObjectList.forEach' call
    var this_1 = this.lmy_1;
    // Inline function 'kotlin.contracts.contract' call
    var content = this_1.sz_1;
    var inductionVariable = 0;
    var last = this_1.tz_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = content[i];
        handlePressInteraction(this, it);
      }
       while (inductionVariable < last);
    this.lmy_1.c3();
  };
  protoOf(RippleNode).f8w = function () {
    var tmp = this.a8w();
    launch(tmp, VOID, VOID, RippleNode$onAttach$slambda_0(this, null));
  };
  protoOf(RippleNode).h92 = function (_this__u8e3s4) {
    _this__u8e3s4.z91();
    var tmp0_safe_receiver = this.hmy_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.run' call
      tmp0_safe_receiver.wmz(_this__u8e3s4, this.imy_1, this.smy());
    }
    this.nmy(_this__u8e3s4);
  };
  function StateLayer$handleInteraction$slambda(this$0, $targetAlpha, $incomingAnimationSpec, resultContinuation) {
    this.fn0_1 = this$0;
    this.gn0_1 = $targetAlpha;
    this.hn0_1 = $incomingAnimationSpec;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StateLayer$handleInteraction$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StateLayer$handleInteraction$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StateLayer$handleInteraction$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.fn0_1.hmz_1.gec(this.gn0_1, this.hn0_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StateLayer$handleInteraction$slambda).q24 = function ($this$launch, completion) {
    var i = new StateLayer$handleInteraction$slambda(this.fn0_1, this.gn0_1, this.hn0_1, completion);
    i.in0_1 = $this$launch;
    return i;
  };
  function StateLayer$handleInteraction$slambda_0(this$0, $targetAlpha, $incomingAnimationSpec, resultContinuation) {
    var i = new StateLayer$handleInteraction$slambda(this$0, $targetAlpha, $incomingAnimationSpec, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function StateLayer$handleInteraction$slambda_1(this$0, $outgoingAnimationSpec, resultContinuation) {
    this.rn0_1 = this$0;
    this.sn0_1 = $outgoingAnimationSpec;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(StateLayer$handleInteraction$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(StateLayer$handleInteraction$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(StateLayer$handleInteraction$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.rn0_1.hmz_1.gec(0.0, this.sn0_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(StateLayer$handleInteraction$slambda_1).q24 = function ($this$launch, completion) {
    var i = new StateLayer$handleInteraction$slambda_1(this.rn0_1, this.sn0_1, completion);
    i.tn0_1 = $this$launch;
    return i;
  };
  function StateLayer$handleInteraction$slambda_2(this$0, $outgoingAnimationSpec, resultContinuation) {
    var i = new StateLayer$handleInteraction$slambda_1(this$0, $outgoingAnimationSpec, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function StateLayer(bounded, rippleAlpha) {
    this.fmz_1 = bounded;
    this.gmz_1 = rippleAlpha;
    this.hmz_1 = Animatable(0.0);
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.imz_1 = ArrayList_init_$Create$();
    this.jmz_1 = null;
  }
  protoOf(StateLayer).kmz = function (interaction, scope) {
    if (interaction instanceof Enter) {
      this.imz_1.j1(interaction);
    } else {
      if (interaction instanceof Exit) {
        this.imz_1.d3(interaction.zi7_1);
      } else {
        if (interaction instanceof Focus) {
          this.imz_1.j1(interaction);
        } else {
          if (interaction instanceof Unfocus) {
            this.imz_1.d3(interaction.bi7_1);
          } else {
            if (interaction instanceof Start) {
              this.imz_1.j1(interaction);
            } else {
              if (interaction instanceof Stop) {
                this.imz_1.d3(interaction.zi6_1);
              } else {
                if (interaction instanceof Cancel_0) {
                  this.imz_1.d3(interaction.ai7_1);
                } else {
                  return Unit_instance;
                }
              }
            }
          }
        }
      }
    }
    var newInteraction = lastOrNull(this.imz_1);
    if (!equals(this.jmz_1, newInteraction)) {
      if (!(newInteraction == null)) {
        var rippleAlpha = this.gmz_1();
        var tmp;
        if (newInteraction instanceof Enter) {
          tmp = rippleAlpha.qmy_1;
        } else {
          if (newInteraction instanceof Focus) {
            tmp = rippleAlpha.pmy_1;
          } else {
            if (newInteraction instanceof Start) {
              tmp = rippleAlpha.omy_1;
            } else {
              tmp = 0.0;
            }
          }
        }
        var targetAlpha = tmp;
        var incomingAnimationSpec = incomingStateLayerAnimationSpecFor(newInteraction);
        launch(scope, VOID, VOID, StateLayer$handleInteraction$slambda_0(this, targetAlpha, incomingAnimationSpec, null));
      } else {
        var outgoingAnimationSpec = outgoingStateLayerAnimationSpecFor(this.jmz_1);
        launch(scope, VOID, VOID, StateLayer$handleInteraction$slambda_2(this, outgoingAnimationSpec, null));
      }
      this.jmz_1 = newInteraction;
    }
  };
  protoOf(StateLayer).wmz = function (_this__u8e3s4, radius, color) {
    var alpha = this.hmz_1.u1();
    if (alpha > 0.0) {
      var modulatedColor = Color__copy$default_impl_ectz3s(color, alpha);
      if (this.fmz_1) {
        // Inline function 'androidx.compose.ui.graphics.drawscope.clipRect' call
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        var this_0 = _this__u8e3s4.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value = _Size___get_packedValue__impl__7rlt1o(this_0);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value, 32));
        var right = floatFromBits(bits);
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        var this_1 = _this__u8e3s4.o5d();
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
        var bottom = floatFromBits(bits_0);
        var clipOp = Companion_getInstance_0().d6e_1;
        // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
        // Inline function 'kotlin.with' call
        var $this$with = _this__u8e3s4.v6p();
        var previousSize = $this$with.o5d();
        $this$with.x5u().t6d();
        try {
          $this$with.p6p().a6e(0.0, 0.0, right, bottom, clipOp);
          _this__u8e3s4.h6q(modulatedColor, radius);
        }finally {
          $this$with.x5u().u6d();
          $this$with.o6p(previousSize);
        }
      } else {
        _this__u8e3s4.h6q(modulatedColor, radius);
      }
    }
  };
  function incomingStateLayerAnimationSpecFor(interaction) {
    _init_properties_Ripple_kt__d55ieo();
    var tmp;
    if (interaction instanceof Enter) {
      tmp = get_DefaultTweenSpec();
    } else {
      if (interaction instanceof Focus) {
        tmp = new TweenSpec(45, VOID, get_LinearEasing());
      } else {
        if (interaction instanceof Start) {
          tmp = new TweenSpec(45, VOID, get_LinearEasing());
        } else {
          tmp = get_DefaultTweenSpec();
        }
      }
    }
    return tmp;
  }
  function outgoingStateLayerAnimationSpecFor(interaction) {
    _init_properties_Ripple_kt__d55ieo();
    var tmp;
    if (interaction instanceof Enter) {
      tmp = get_DefaultTweenSpec();
    } else {
      if (interaction instanceof Focus) {
        tmp = get_DefaultTweenSpec();
      } else {
        if (interaction instanceof Start) {
          tmp = new TweenSpec(150, VOID, get_LinearEasing());
        } else {
          tmp = get_DefaultTweenSpec();
        }
      }
    }
    return tmp;
  }
  var properties_initialized_Ripple_kt_3wqvym;
  function _init_properties_Ripple_kt__d55ieo() {
    if (!properties_initialized_Ripple_kt_3wqvym) {
      properties_initialized_Ripple_kt_3wqvym = true;
      DefaultTweenSpec = new TweenSpec(15, VOID, get_LinearEasing());
      androidx_compose_material_ripple_Ripple$stable = 0;
      androidx_compose_material_ripple_RippleIndicationInstance$stable = 8;
      androidx_compose_material_ripple_RippleNode$stable = 8;
    }
  }
  function get_BoundedRippleExtraRadius() {
    _init_properties_RippleAnimation_kt__8sy0vy();
    return BoundedRippleExtraRadius;
  }
  var BoundedRippleExtraRadius;
  var androidx_compose_material_ripple_RippleAnimation$stable;
  function RippleAnimation$fadeIn$slambda$slambda(this$0, resultContinuation) {
    this.cn1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleAnimation$fadeIn$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.cn1_1.emw_1.gec(1.0, tween(75, VOID, get_LinearEasing()), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new RippleAnimation$fadeIn$slambda$slambda(this.cn1_1, completion);
    i.dn1_1 = $this$launch;
    return i;
  };
  function RippleAnimation$fadeIn$slambda$slambda_0(this$0, resultContinuation) {
    var i = new RippleAnimation$fadeIn$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RippleAnimation$fadeIn$slambda$slambda_1(this$0, resultContinuation) {
    this.mn1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleAnimation$fadeIn$slambda$slambda_1).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda_1).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.mn1_1.fmw_1.gec(1.0, tween(225, VOID, get_FastOutSlowInEasing()), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda_1).q24 = function ($this$launch, completion) {
    var i = new RippleAnimation$fadeIn$slambda$slambda_1(this.mn1_1, completion);
    i.nn1_1 = $this$launch;
    return i;
  };
  function RippleAnimation$fadeIn$slambda$slambda_2(this$0, resultContinuation) {
    var i = new RippleAnimation$fadeIn$slambda$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RippleAnimation$fadeIn$slambda$slambda_3(this$0, resultContinuation) {
    this.wn1_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleAnimation$fadeIn$slambda$slambda_3).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda_3).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.wn1_1.gmw_1.gec(1.0, tween(225, VOID, get_LinearEasing()), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RippleAnimation$fadeIn$slambda$slambda_3).q24 = function ($this$launch, completion) {
    var i = new RippleAnimation$fadeIn$slambda$slambda_3(this.wn1_1, completion);
    i.xn1_1 = $this$launch;
    return i;
  };
  function RippleAnimation$fadeIn$slambda$slambda_4(this$0, resultContinuation) {
    var i = new RippleAnimation$fadeIn$slambda$slambda_3(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function RippleAnimation$fadeOut$slambda$slambda(this$0, resultContinuation) {
    this.gn2_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleAnimation$fadeOut$slambda$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation$fadeOut$slambda$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleAnimation$fadeOut$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.gn2_1.emw_1.gec(0.0, tween(150, VOID, get_LinearEasing()), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RippleAnimation$fadeOut$slambda$slambda).q24 = function ($this$launch, completion) {
    var i = new RippleAnimation$fadeOut$slambda$slambda(this.gn2_1, completion);
    i.hn2_1 = $this$launch;
    return i;
  };
  function RippleAnimation$fadeOut$slambda$slambda_0(this$0, resultContinuation) {
    var i = new RippleAnimation$fadeOut$slambda$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function _set_finishedFadingIn__33hlo9($this, _set____db54di) {
    var tmp0 = $this.imw_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RippleAnimation$_get_finishedFadingIn_$ref_fbtyx2();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('finishedFadingIn', 1, tmp, tmp_0, RippleAnimation$_set_finishedFadingIn_$ref_1drawq());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_finishedFadingIn__pzmnej($this) {
    var tmp0 = $this.imw_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RippleAnimation$_get_finishedFadingIn_$ref_fbtyx2();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('finishedFadingIn', 1, tmp, tmp_0, RippleAnimation$_set_finishedFadingIn_$ref_1drawq());
    return tmp0.u1();
  }
  function _set_finishRequested__u52oy2($this, _set____db54di) {
    var tmp0 = $this.jmw_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RippleAnimation$_get_finishRequested_$ref_hndrqt();
    // Inline function 'androidx.compose.runtime.setValue' call
    getPropertyCallableRef('finishRequested', 1, tmp, tmp_0, RippleAnimation$_set_finishRequested_$ref_4cniuh());
    tmp0.s21(_set____db54di);
    return Unit_instance;
  }
  function _get_finishRequested__usb5ii($this) {
    var tmp0 = $this.jmw_1;
    var tmp = KMutableProperty1;
    var tmp_0 = RippleAnimation$_get_finishRequested_$ref_hndrqt();
    // Inline function 'androidx.compose.runtime.getValue' call
    getPropertyCallableRef('finishRequested', 1, tmp, tmp_0, RippleAnimation$_set_finishRequested_$ref_4cniuh());
    return tmp0.u1();
  }
  function fadeIn($this, $completion) {
    var tmp = new $fadeInCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function fadeOut($this, $completion) {
    var tmp = new $fadeOutCOROUTINE$($this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function RippleAnimation$_get_finishedFadingIn_$ref_fbtyx2() {
    return constructCallableReference(function (p0) {
      return _get_finishedFadingIn__pzmnej(p0);
    }, 1, 0, 391);
  }
  function RippleAnimation$_set_finishedFadingIn_$ref_1drawq() {
    return constructCallableReference(function (p0, p1) {
      _set_finishedFadingIn__33hlo9(p0, p1);
      return Unit_instance;
    }, 2, 0, 392);
  }
  function RippleAnimation$_get_finishRequested_$ref_hndrqt() {
    return constructCallableReference(function (p0) {
      return _get_finishRequested__usb5ii(p0);
    }, 1, 0, 393);
  }
  function RippleAnimation$_set_finishRequested_$ref_4cniuh() {
    return constructCallableReference(function (p0, p1) {
      _set_finishRequested__u52oy2(p0, p1);
      return Unit_instance;
    }, 2, 0, 394);
  }
  function RippleAnimation$fadeIn$slambda(this$0, resultContinuation) {
    this.in3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleAnimation$fadeIn$slambda).rjp = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation$fadeIn$slambda).ja = function (p1, $completion) {
    return this.rjp((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleAnimation$fadeIn$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          launch(this.jn3_1, VOID, VOID, RippleAnimation$fadeIn$slambda$slambda_0(this.in3_1, null));
          launch(this.jn3_1, VOID, VOID, RippleAnimation$fadeIn$slambda$slambda_2(this.in3_1, null));
          return launch(this.jn3_1, VOID, VOID, RippleAnimation$fadeIn$slambda$slambda_4(this.in3_1, null));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(RippleAnimation$fadeIn$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new RippleAnimation$fadeIn$slambda(this.in3_1, completion);
    i.jn3_1 = $this$coroutineScope;
    return i;
  };
  function RippleAnimation$fadeIn$slambda_0(this$0, resultContinuation) {
    var i = new RippleAnimation$fadeIn$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rjp($this$coroutineScope, $completion);
    }, 1);
  }
  function RippleAnimation$fadeOut$slambda(this$0, resultContinuation) {
    this.sn3_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RippleAnimation$fadeOut$slambda).rjp = function ($this$coroutineScope, $completion) {
    var tmp = this.q24($this$coroutineScope, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation$fadeOut$slambda).ja = function (p1, $completion) {
    return this.rjp((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(RippleAnimation$fadeOut$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          return launch(this.tn3_1, VOID, VOID, RippleAnimation$fadeOut$slambda$slambda_0(this.sn3_1, null));
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(RippleAnimation$fadeOut$slambda).q24 = function ($this$coroutineScope, completion) {
    var i = new RippleAnimation$fadeOut$slambda(this.sn3_1, completion);
    i.tn3_1 = $this$coroutineScope;
    return i;
  };
  function RippleAnimation$fadeOut$slambda_0(this$0, resultContinuation) {
    var i = new RippleAnimation$fadeOut$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$coroutineScope, $completion) {
      return i.rjp($this$coroutineScope, $completion);
    }, 1);
  }
  function $animateCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cn4_1 = _this__u8e3s4;
  }
  protoOf($animateCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = fadeIn(this.cn4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            _set_finishedFadingIn__33hlo9(this.cn4_1, true);
            this.n9_1 = 2;
            suspendResult = this.cn4_1.hmw_1.r1c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 3;
            suspendResult = fadeOut(this.cn4_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $fadeInCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.qn2_1 = _this__u8e3s4;
  }
  protoOf($fadeInCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(RippleAnimation$fadeIn$slambda_0(this.qn2_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $fadeOutCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zn2_1 = _this__u8e3s4;
  }
  protoOf($fadeOutCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = coroutineScope(RippleAnimation$fadeOut$slambda_0(this.zn2_1, null), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function RippleAnimation(origin, radius, bounded) {
    this.zmv_1 = origin;
    this.amw_1 = radius;
    this.bmw_1 = bounded;
    this.cmw_1 = null;
    this.dmw_1 = null;
    this.emw_1 = Animatable(0.0);
    this.fmw_1 = Animatable(0.0);
    this.gmw_1 = Animatable(0.0);
    this.hmw_1 = CompletableDeferred(null);
    this.imw_1 = mutableStateOf(false);
    this.jmw_1 = mutableStateOf(false);
  }
  protoOf(RippleAnimation).kmw = function ($completion) {
    var tmp = new $animateCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RippleAnimation).mmx = function () {
    _set_finishRequested__u52oy2(this, true);
    this.hmw_1.u1g(Unit_instance);
  };
  protoOf(RippleAnimation).tmy = function (_this__u8e3s4, color) {
    if (this.cmw_1 == null) {
      this.cmw_1 = getRippleStartRadius(_this__u8e3s4.o5d());
    }
    var tmp = this.zmv_1;
    if ((tmp == null ? null : new Offset(tmp)) == null) {
      this.zmv_1 = _this__u8e3s4.m6q();
    }
    var tmp_0 = this.dmw_1;
    if ((tmp_0 == null ? null : new Offset(tmp_0)) == null) {
      var tmp_1 = this;
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var tmp0 = floatFromBits(bits) / 2.0;
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = floatFromBits(bits_0) / 2.0;
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp_1.dmw_1 = _Offset___init__impl__c168vi(tmp$ret$9);
    }
    var tmp_2;
    if (_get_finishRequested__usb5ii(this) && !_get_finishedFadingIn__pzmnej(this)) {
      tmp_2 = 1.0;
    } else {
      tmp_2 = this.emw_1.u1();
    }
    var alpha = tmp_2;
    var radius = lerp(ensureNotNull(this.cmw_1), this.amw_1, this.fmw_1.u1());
    var tmp_3 = this.zmv_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_2 = ensureNotNull(tmp_3 == null ? null : new Offset(tmp_3)).e5d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_4 = floatFromBits(bits_1);
    var tmp_5 = this.dmw_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_3 = ensureNotNull(tmp_5 == null ? null : new Offset(tmp_5)).e5d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(this_3);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    var tmp$ret$14 = floatFromBits(bits_2);
    var tmp0_0 = lerp(tmp_4, tmp$ret$14, this.gmw_1.u1());
    var tmp_6 = this.zmv_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_4 = ensureNotNull(tmp_6 == null ? null : new Offset(tmp_6)).e5d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(this_4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_7 = floatFromBits(bits_3);
    var tmp_8 = this.dmw_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_5 = ensureNotNull(tmp_8 == null ? null : new Offset(tmp_8)).e5d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _Offset___get_packedValue__impl__xh2k8q(this_5);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp$ret$22 = floatFromBits(bits_4);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2_0 = lerp(tmp_7, tmp$ret$22, this.gmw_1.u1());
    var v1_0 = fromInt(toRawBits(tmp0_0));
    var v2_0 = fromInt(toRawBits(val2_0));
    var tmp$ret$27 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
    var centerOffset = _Offset___init__impl__c168vi(tmp$ret$27);
    var modulatedColor = Color__copy$default_impl_ectz3s(color, _Color___get_alpha__impl__wcfyv1(color) * alpha);
    if (this.bmw_1) {
      // Inline function 'androidx.compose.ui.graphics.drawscope.clipRect' call
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_6 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_5 = _Size___get_packedValue__impl__7rlt1o(this_6);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_5 = convertToInt(shiftRight(value_5, 32));
      var right = floatFromBits(bits_5);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_7 = _this__u8e3s4.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_6 = _Size___get_packedValue__impl__7rlt1o(this_7);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
      var bottom = floatFromBits(bits_6);
      var clipOp = Companion_getInstance_0().d6e_1;
      // Inline function 'androidx.compose.ui.graphics.drawscope.withTransform' call
      // Inline function 'kotlin.with' call
      var $this$with = _this__u8e3s4.v6p();
      var previousSize = $this$with.o5d();
      $this$with.x5u().t6d();
      try {
        $this$with.p6p().a6e(0.0, 0.0, right, bottom, clipOp);
        _this__u8e3s4.h6q(modulatedColor, radius, centerOffset);
      }finally {
        $this$with.x5u().u6d();
        $this$with.o6p(previousSize);
      }
    } else {
      _this__u8e3s4.h6q(modulatedColor, radius, centerOffset);
    }
  };
  function getRippleEndRadius(_this__u8e3s4, bounded, size) {
    _init_properties_RippleAnimation_kt__8sy0vy();
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = floatFromBits(bits_0);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp$ret$8 = _Offset___init__impl__c168vi(tmp$ret$9);
    var radiusCoveringBounds = Offset__getDistance_impl_pclvxn(tmp$ret$8) / 2.0;
    var tmp;
    if (bounded) {
      tmp = radiusCoveringBounds + _this__u8e3s4.v5e(get_BoundedRippleExtraRadius());
    } else {
      tmp = radiusCoveringBounds;
    }
    return tmp;
  }
  function getRippleStartRadius(size) {
    _init_properties_RippleAnimation_kt__8sy0vy();
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'kotlin.math.max' call
    var b = floatFromBits(bits_0);
    return Math.max(tmp0, b) * 0.3;
  }
  var properties_initialized_RippleAnimation_kt_4ja21o;
  function _init_properties_RippleAnimation_kt__8sy0vy() {
    if (!properties_initialized_RippleAnimation_kt_4ja21o) {
      properties_initialized_RippleAnimation_kt_4ja21o = true;
      // Inline function 'androidx.compose.ui.unit.dp' call
      BoundedRippleExtraRadius = _Dp___init__impl__ms3zkb(10);
      androidx_compose_material_ripple_RippleAnimation$stable = 8;
    }
  }
  function RippleAlpha(draggedAlpha, focusedAlpha, hoveredAlpha, pressedAlpha) {
    this.omy_1 = draggedAlpha;
    this.pmy_1 = focusedAlpha;
    this.qmy_1 = hoveredAlpha;
    this.rmy_1 = pressedAlpha;
  }
  protoOf(RippleAlpha).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RippleAlpha))
      return false;
    if (!(this.omy_1 === other.omy_1))
      return false;
    if (!(this.pmy_1 === other.pmy_1))
      return false;
    if (!(this.qmy_1 === other.qmy_1))
      return false;
    if (!(this.rmy_1 === other.rmy_1))
      return false;
    return true;
  };
  protoOf(RippleAlpha).hashCode = function () {
    var result = getNumberHashCode(this.omy_1);
    result = imul(31, result) + getNumberHashCode(this.pmy_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.qmy_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.rmy_1) | 0;
    return result;
  };
  protoOf(RippleAlpha).toString = function () {
    return 'RippleAlpha(draggedAlpha=' + this.omy_1 + ', focusedAlpha=' + this.pmy_1 + ', ' + ('hoveredAlpha=' + this.qmy_1 + ', pressedAlpha=' + this.rmy_1 + ')');
  };
  function createPlatformRippleNode(interactionSource, bounded, radius, color, rippleAlpha) {
    return new CommonRippleNode(interactionSource, bounded, radius, color, rippleAlpha);
  }
  //region block: post-declaration
  protoOf(RippleNode).v95 = onMeasureResultChanged;
  protoOf(RippleNode).x91 = onPlaced;
  //endregion
  //region block: init
  androidx_compose_material_ripple_CommonRipple$stable = 0;
  androidx_compose_material_ripple_CommonRippleNode$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = RippleAlpha;
  _.$_$.b = createRippleModifierNode;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-material-material-ripple.js.map
